import api from '@/network';

export interface AssessmentMetricTest {
    TestName: string;
    TestTitle: string;
}

export type AssessmentMetric = {
    ModelName: string;
    ModelTitle: string;
    MainTests: AssessmentMetricTest[];
};

export default {
    async getMetrics(): Promise<AssessmentMetric[]> {
        const response = await api.get(`metrics`);
        return (response.data.CompetModels as AssessmentMetric[]) ?? [];
    },
};
